/* istanbul ignore file */
export { default } from './PageTitle';
